import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from 'react';
import IconifyIcon from "src/@core/components/icon";
import { dateFormatter } from "src/utils/formatters";
import { HttpSupplierOrders } from "../api/HttpSupplierOrders";
import { SupplierOrderHistory } from "../types/dto";
import SupplierOrderStatusChip from './SupplierOrderChip';
import { SupplierOrderFields, SupplierOrderHistoryFields } from "../types/fields";

interface SupplierOrderHistoryDialogProps {
    open: boolean;
    onClose: () => void;
    orderId: number;
}

const SupplierOrderHistoryDialog = ({ open, onClose, orderId }: SupplierOrderHistoryDialogProps) => {
    const [history, setHistory] = useState<SupplierOrderHistory[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open && orderId) {
            setLoading(true);
            HttpSupplierOrders.getHistory(orderId)
                .then(data => setHistory(data))
                .catch(console.error)
                .finally(() => setLoading(false));
        }
    }, [open, orderId]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <IconifyIcon icon="mdi:history" fontSize="1.5rem" />
                Historial de Cambios
            </DialogTitle>
            <DialogContent dividers>
                {loading ? (
                    <Box display="flex" justifyContent="center" p={3}>
                        <CircularProgress />
                    </Box>
                ) : history.length === 0 ? (
                    <Typography align="center" color="text.secondary">
                        No hay historial registrado.
                    </Typography>
                ) : (
                    <Stack spacing={2}>
                        {/* historial de cambios */}
                        {history.map((item: SupplierOrderHistory, index) => {

                            return (
                                <Box key={index} sx={{
                                    borderLeft: '2px solid #ddd',
                                    pl: 2,
                                    ml: 1,
                                    position: 'relative',
                                    pb: 2
                                }}>
                                    {/* circulito de historial */}
                                    <Box sx={{
                                        position: 'absolute',
                                        left: '-6px',
                                        top: 0,
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '50%',
                                        bgcolor: 'primary.main'
                                    }} />

                                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                                        <Typography variant="caption" color="text.secondary">
                                            {dateFormatter.toShortDate(item.fechaHistoria)} {new Date(item.fechaHistoria).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                        </Typography>
                                        <Typography variant="caption" fontWeight="bold">
                                            {item.usuarioModificacion}
                                        </Typography>
                                    </Stack>

                                    <Box sx={{ bgcolor: 'background.default', p: 1.5, borderRadius: 1 }}>
                                        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                            <Typography variant="body2" fontWeight="bold">Estado:</Typography>

                                            <SupplierOrderStatusChip SupplierOrderOption={item} />

                                        </Stack>

                                        <Stack spacing={0.5}>
                                            {
                                                
                                                <Typography variant="caption" display="block">
                                                    <b>Pedidos:</b> {item[SupplierOrderFields.Items]}
                                                </Typography>
                                            }
                                            {item.nombreProveedor && (
                                                <Typography variant="caption" display="block">
                                                    <b>Proveedor:</b> {item[SupplierOrderHistoryFields.ProviderName]}
                                                </Typography>
                                            )}
                                            {item.transporte && (
                                                <Typography variant="caption" display="block">
                                                    <b>Transporte:</b> {item[SupplierOrderHistoryFields.Transport]}
                                                </Typography>
                                            )}
                                            {item.fechaEntrega && (
                                                <Typography variant="caption" display="block">
                                                    <b>Entrega:</b> {dateFormatter.toShortDate(item[SupplierOrderHistoryFields.DeliveryDate])}
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Box>
                                </Box>
                            );
                        })}
                    </Stack>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SupplierOrderHistoryDialog;
